import { ApolloQueryResult, OperationVariables } from "@apollo/client";
import { useEffect, useState } from "react";

const usePagination = (
    total: number,
    limit: number,
    refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<ApolloQueryResult<any>>,
) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [offset, setOffset] = useState(0);

    useEffect(() => {
        setTotalPages(Math.ceil(total / limit));
    }, [total, limit]);

    useEffect(() => {
        refetch({ offset });
    }, [offset, refetch]);

    const handlePreviousPage = () => {
        if (currentPage === 1) return;
        setCurrentPage(currentPage - 1);
        setOffset(offset - limit);
    };

    const handleNextPage = () => {
        if (currentPage === totalPages) return;
        setCurrentPage(currentPage + 1);
        setOffset(offset + limit);
    };

    const handleSetPage = (page: number) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
        setOffset((page - 1) * limit);
    };

    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;

    return {
        currentPage,
        totalPages,
        handlePreviousPage,
        handleNextPage,
        handleSetPage,
        isFirstPage,
        isLastPage,
    };
};

export default usePagination;
